import classNames from 'classnames';
import ConditionalInput from '../ConditionalInput';
import React, { useCallback } from 'react';
import { CheckIcon, Flex, Group, Input, rem, Select, Text } from '@mantine/core';
import { TbChevronDown } from 'react-icons/tb';
import { VARIABLE_TYPES_ARRAY, variableTypes } from '../../../../../../../consts/variableTypes';
import { TbTypography, TbCalendar } from 'react-icons/tb';
import { GoNumber } from 'react-icons/go';

export const CreateColumn = ({
  item,
  onChangeInputType,
  onChangeInput,
  onChangeColumn,
  onChangeReplaceColumn,
  filterTypes
}) => {
  const filterTypeId = filterTypes?.[0]?.id;

  return (
    <div id="grid-table-create-column-root" className="">
      <div
        id="grid-table-create-column-card"
        className={classNames('filter_card', {
          ['noBorderBottom']: false,
          ['isDisableBefore']: true
        })}
        style={{
          marginTop: '-10px',
          position: 'relative',
          zIndex: 16
        }}
      >
        <div id="grid-table-create-column-content" className="filter_content">
          <div id="grid-table-create-column-form" className="form-element">
            <Flex id="grid-table-create-column-row" gap={rem(8)} mt={rem(10)}>
              <Flex id="grid-table-create-column-name" direction="column" w="150px">
                <Text
                  id="grid-table-create-column-name-label"
                  size={rem(12)}
                  fw={600}
                  mb={rem(12)}
                  display="flex"
                >
                  Column Name<Text c="red">*</Text>
                </Text>

                <Input
                  id="grid-table-create-column-name-input"
                  size="xs"
                  value={item.column}
                  placeholder="Enter Column Name"
                  required
                  error={item.errors?.includes('column')}
                  onChange={e => onChangeColumn(filterTypeId, item?.id, e.target.value)}
                  w={rem(150)}
                />
              </Flex>

              <ConditionalInput
                id="grid-table-create-column-value"
                required={true}
                hiddenVariants={['column', 'ai_input']}
                type={item?.inputType}
                label="Fill Value"
                value={item?.value?.[item?.inputType]}
                onChangeType={val => onChangeInputType(filterTypeId, item?.id, val)}
                onChangeValue={val => onChangeInput(filterTypeId, item?.id, val)}
                containerProps={{
                  style: {
                    width: '200px'
                  }
                }}
              />

              <Select
                id="grid-table-create-column-type"
                size="xs"
                value={item.replaceColumn}
                onChange={val => onChangeReplaceColumn(filterTypeId, item?.id, val)}
                data={VARIABLE_TYPES_ARRAY}
                label="Type"
                w={rem(130)}
                leftSection={!item.replaceColumn ? null : getFieldTypeIcon(item.replaceColumn)}
                rightSection={<TbChevronDown size={12} />}
                renderOption={renderSelectOption}
              />
            </Flex>
          </div>
        </div>
      </div>
    </div>
  );
};

const getFieldTypeIcon = value => {
  if (value?.includes(variableTypes.STRING))
    return (
      <TbTypography
        fontSize="12px"
        style={{
          minWidth: '12px'
        }}
      />
    );

  if (value?.includes(variableTypes.NUMBER))
    return (
      <GoNumber
        fontSize="12px"
        style={{
          minWidth: '12px'
        }}
      />
    );

  if (value?.includes(variableTypes.DATE_TIME))
    return (
      <TbCalendar
        fontSize="12px"
        style={{
          minWidth: '12px'
        }}
      />
    );

  return <></>;
};

const renderSelectOption = ({ option, checked }) => {
  return (
    <Group flex="1" gap="xs">
      {getFieldTypeIcon(option.value)}
      {option.label}
      {checked && <CheckIcon size={12} />}
    </Group>
  );
};
